import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const ReligionForm = ({ religionId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [religionName, setReligionName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.religion) {
               setReligionName(initialData.religion);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!religionName.trim()) {
               setError('Religion name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (religionId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateReligionById/${religionId}`;
                    body = { religion: religionName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createReligion`;
                    body = { religion: religionName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(religionId ? 'Religion updated successfully' : 'Religion created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/religion');
               } else {
                    setError(data.message || `Failed to ${religionId ? 'update' : 'create'} PYAGROUP`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               {/* <h2 className="section-title">{religionId ? 'Edit Religion' : 'Add Religion'}</h2> */}
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="religionName"
                              placeholder=" "
                              autoComplete="off"
                              value={religionName}
                              onChange={(e) => setReligionName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="religionName">Religion Name</label>
                    </div>
               </div>
               {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
               <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: '15px' }}
                    disabled={loading}
               >
                    {loading ? 'Saving...' : 'Save'}
               </button>
          </form>
     );
};

export default ReligionForm;